import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import { AssessmentQuestionBase } from './models/assessment-question-base.model';
import { FormService } from '../form/form.service';

@Component({
    selector: 'app-assessment-question',
    templateUrl: './assessment-form-question.component.html',
    standalone: false
})
export class AssessmentFormQuestionComponent {
  @Input() question: AssessmentQuestionBase<string>;
  @Input() form: FormGroup;
  @Input() config: any = {};
  @Input() action: string;
  @Input() disabled_field: boolean = false;
  calculation_formula : any;
  constructor(
    private formService: FormService
  ) {
  }

  ngOnInit() {
    console.log("question:::",this.question);
    this.form.controls[this.question.key]['question_component'] = this;
    if(this.form.controls[this.question.key]['question_component'].question.calculated_field){
      this.disabled_field = true;
    }
    else{
      this.disabled_field = false;
    }
  }
  get isValid() {
    return this.form.controls[this.question.key].valid;
  }
  valueChange(event, question, isManual = true) {
    console.log("event:::",event.target.value);
    question.value = event.target.value;
    this.form.controls[question.key].setValue(event.target.value);    
  }
  getDivClass(question) {
    let className = 'form-element';
    if (!this.isValid) {
      if (question.controlType == 'textentry')
        className += ' error dd-error';
      else if (question.controlType == 'singleChoice')
        className += ' error dd-error';
      else if (question.disabled != undefined && question.disabled == true)
        className += '';
      else
        className += ' error';
    }

    return className;
  }
}